export class Gifts {
  constructor(http) {
    this.http = http;
  }

  fetchGifts(filter) {
    return this.http.get('gifts', { params: { type: filter } });
  }

  fetchGiftsGrouping() {
    return new Promise(resolve =>
      resolve({
        selected: { value: 'none', label: '\u043d\u0435\u0442' },
        options: [
          { value: 'default', label: '\u043d\u0435\u0442' },
          { value: 'id', label: 'панель' }
        ]
      })
    );
  }
}
